// Uma chave por `codigo` estável da API (ver DomainError). Cada spec acrescenta as suas.
export const erros = {
  REQUISICAO_INVALIDA: 'Os dados enviados são inválidos.',
  NAO_AUTENTICADO: 'Sua sessão expirou. Entre novamente.',
  SEM_PERMISSAO: 'Você não tem permissão para esta ação.',
  NAO_ENCONTRADO: 'Não encontrado.',
  MUITAS_REQUISICOES: 'Muitas tentativas. Aguarde um minuto.',
  ERRO_INESPERADO: 'Ocorreu um erro inesperado. Tente novamente.',
  REDE: 'Falha de conexão. Tente novamente.',
  CREDENCIAIS_INVALIDAS: 'E-mail ou senha inválidos.',
  USUARIO_NAO_ENCONTRADO: 'Usuário não encontrado.',
  USUARIO_JA_EXISTE: 'Já existe um usuário com este e-mail.',
  LOGIN_SENHA_DESLIGADO: 'O login por senha está desligado.',
  REFRESH_INVALIDO: 'Sua sessão expirou. Entre novamente.',
  AXIIS_INDISPONIVEL:
    'O cadastro de profissionais está temporariamente indisponível. Tente novamente em alguns minutos.',
  PERIODO_INVALIDO: 'A data de fim não pode ser anterior à de início.',
  ENTREGA_PREVISTA_INVALIDA:
    'Informe as duas datas e que a data final não seja anterior à inicial.',
  OUTRA_CAMPANHA_ATIVA: 'Já existe uma campanha ativa: {{nome}}. Desative-a antes.',
  CAMPANHA_NAO_ENCONTRADA: 'Campanha não encontrada.',
  CEP_INVALIDO: 'O CEP precisa ter 8 dígitos.',
  CEP_NAO_ENCONTRADO: 'CEP não encontrado.',
  CEP_INDISPONIVEL: 'A consulta de CEP está temporariamente indisponível.',
  RESPOSTA_INVALIDA: 'Há respostas inválidas. Confira os campos marcados.',
  RESPOSTA_DESATUALIZADA:
    'Suas respostas foram alteradas em outra janela. Mostramos a versão mais recente; confira antes de salvar de novo.',
  SEM_VINCULO:
    'Não encontramos seu cadastro de profissional. Procure a equipe responsável pela campanha.',
  NAO_PARTICIPANTE:
    'Você não está na lista de participantes desta campanha. Procure a equipe responsável pela campanha.',
  PARTICIPANTE_EXCLUIDO: 'Você não faz mais parte desta campanha.',
  CAMPANHA_AGENDADA: 'A campanha ainda não começou.',
  CAMPANHA_FECHADA: 'A campanha não está aceitando respostas.',
  EXPORTACAO_INCONSISTENTE:
    'Respostas com endereço ou tamanho inválido: {{quantidade}}. Leve a lista abaixo ao suporte do sistema antes de exportar.',
  PARTICIPANTE_NAO_ENCONTRADO: 'Participante não encontrado.',
  AZURE_NAO_CONFIGURADO: 'O login Microsoft não está configurado.',
  CAMPANHA_NAO_SINCRONIZAVEL: 'Só é possível sincronizar uma campanha que não terminou.',
  CAMPANHA_TERMINADA: 'O prazo desta campanha já terminou.',
  ULTIMO_ADMINISTRADOR: 'O sistema precisa de ao menos um administrador ativo.',
  SINCRONIZACAO_EM_ANDAMENTO: 'Já existe uma sincronização em andamento. Aguarde.',
  CAMPANHA_SEM_RETENTATIVA: 'Só é possível tentar de novo numa campanha ativa.',
  RODADA_EM_ANDAMENTO: 'Já existe um envio em andamento para esta campanha.',
  CAMPANHA_SEM_CONVITE: 'Só é possível enviar convites de uma campanha ativa que não terminou.',
  SELECAO_DESATUALIZADA: 'A lista mudou desde que você selecionou. Revise e tente de novo.',
  VARIAVEL_DESCONHECIDA:
    'O texto tem uma variável desconhecida. Use {nome}, {campanha}, {inicio} ou {fim}.',
  SELECAO_VAZIA: 'Ninguém da seleção está na campanha para receber o convite.',
  INATIVO_NO_AXIIS: 'Esta pessoa está inativa no cadastro e não pode voltar à campanha.',
  JA_PARTICIPANTE: 'Esta pessoa já é participante da campanha.',
  NAO_ENCONTRADO_NO_AXIIS: 'Esta pessoa não foi encontrada no cadastro.',
  EXPORTACAO_MUITO_GRANDE:
    'A lista tem {{quantidade}} pessoas; o máximo por arquivo é 5000. Aplique filtros e exporte de novo.',
} as const;
